/*global angular*/
module.exports = ['$q', 'settings', '$state', function ($q, settings, $state) {
  'use strict';
  return {
    restrict: 'E',
    template: require('./collapsedContent.html'),
    replace: true,
    transclude: true,
    scope: {
      content: '='
    },
    //require: [ '^xyz' ], //requires a controller from the parent scope
    link: function (scope, element, attrs) {
    }
  };
}];



// WEBPACK FOOTER //
// ./web/js/module/visionText/js/collapsedContent/collapsedContent.js